const UNIT_LABELS: Record<string, string> = {
    millimeters: "mm",
    centimeters: "cm",
    inches: "in",
    inches_decimal: "in",
    points: "pt",
    picas: "pc",
    pixels: "px",
    agates: "ag",
    ciceros: "c",
    custom: "",
    u: "u",
    bai: "bai",
    mils: "mil",
};

const DEFAULT_INDESIGN_PREVIEW_DPI = 72;
const MILLIMETERS_PER_INCH = 25.4;
const CENTIMETERS_PER_INCH = 2.54;
const POINTS_PER_INCH = 72;
const PICAS_PER_INCH = 6;

function normalizeIndesignMeasurementUnit(measurementUnit: string | undefined): string | undefined {
    return measurementUnit?.toLowerCase();
}

export function getIndesignUnitLabel(measurementUnit: string | undefined): string {
    if (!measurementUnit) {
        return "";
    }
    const normalizedUnit = normalizeIndesignMeasurementUnit(measurementUnit);
    const label = normalizedUnit ? UNIT_LABELS[normalizedUnit] : undefined;
    return label !== undefined ? label : measurementUnit;
}

export function formatIndesignDimension(value: number, measurementUnit: string | undefined): string {
    const label = getIndesignUnitLabel(measurementUnit);
    return label ? `${value}${label}` : `${value}`;
}

export function convertIndesignDimensionToPixels(
    value: number,
    measurementUnit: string | undefined,
    dpi = DEFAULT_INDESIGN_PREVIEW_DPI,
): number {
    switch (normalizeIndesignMeasurementUnit(measurementUnit)) {
        case "millimeters":
            return (value / MILLIMETERS_PER_INCH) * dpi;
        case "centimeters":
            return (value / CENTIMETERS_PER_INCH) * dpi;
        case "inches":
        case "inches_decimal":
            return value * dpi;
        case "points":
            return (value / POINTS_PER_INCH) * dpi;
        case "picas":
            return (value / PICAS_PER_INCH) * dpi;
        case "pixels":
        default:
            return value;
    }
}

export function convertPixelsToIndesignDimension(
    value: number,
    measurementUnit: string | undefined,
    dpi = DEFAULT_INDESIGN_PREVIEW_DPI,
): number {
    switch (normalizeIndesignMeasurementUnit(measurementUnit)) {
        case "millimeters":
            return (value / dpi) * MILLIMETERS_PER_INCH;
        case "centimeters":
            return (value / dpi) * CENTIMETERS_PER_INCH;
        case "inches":
        case "inches_decimal":
            return value / dpi;
        case "points":
            return (value / dpi) * POINTS_PER_INCH;
        case "picas":
            return (value / dpi) * PICAS_PER_INCH;
        case "pixels":
        default:
            return value;
    }
}
